import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Subscribed with:', email);
    setEmail('');
    alert('Thank you for subscribing to our newsletter!');
  };

  return (
    <footer id="contact">
      <div className="container">
        <div className="footer-container">
          <div className="footer-col">
            <h3>Nengai Foundation</h3>
            <p>Spread Love & Spread Hope</p>
            <p>Helping children with autism in the Maasai community reach their full potential.</p>
            <div className="social-links">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaLinkedinIn /></a>
            </div>
          </div>
          <div className="footer-col">
            <h3>Contact Us</h3>
            <p><FaMapMarkerAlt className="contact-icon" /> Arusha, Tanzania</p>
            <p><FaPhoneAlt className="contact-icon" /> +255 687 392 708</p>
            <p><FaEnvelope className="contact-icon" /> info@nengaifoundation.org</p>

          </div>
          <div className="footer-col">
            <h3>Quick Links</h3>
            <p><a href="#about">About Us</a></p>
            <p><a href="#aims">Our Programs</a></p>
            <p><a href="#gallery">Gallery</a></p>
            <p><a href="#donate">Donate</a></p>
          </div>
          <div className="footer-col">
            <h3>Newsletter</h3>
            <p>Subscribe to our newsletter to receive updates about our work and how you can help.</p>
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="btn">Subscribe</button>
            </form>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; {new Date().getFullYear()} Nengai Foundation. All Rights Reserved. | Spread Love & Spread Hope</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;